import AdminLoadable from 'components/core/AdminLoadable';
import { SharedToolbarViewProps } from './ToolbarView';

export default AdminLoadable<SharedToolbarViewProps>({
  loader: () => import('./Toolbar'),
  name: 'Toolbar',
});
